<template>
  <div>
    <SysDialogFullScreen
      v-model="DIALOG_COMPUTED"
      titulo="Relatório de Status Produto"
    >
      <template #titulo>
        <v-btn icon dark class="ml-n4 mr-4" @click="fecharDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <span class="font-20">Detalhamento</span>

        <v-divider vertical dark inset class="mx-4"/>

        <div class="font-12">
          <span class="ma-0" v-for="(descricao, key) in ARRAY_DESCRICAO_STATUS" :key="key">
            {{ descricao }}
            <v-icon dark small v-if="key !== ARRAY_DESCRICAO_STATUS.length - 1">mdi-chevron-right</v-icon>
          </span>
        </div>
      </template>

      <sys-data-table
        :headers="headers"
        :items="desserts"
        :height="alturaDaJanela - 157"
        :itemHeight="45"
        :search="pesquisar"
        class="ml-2 mr-1"
        @scroll-items="verificarFimScroll($event)"
      >
        <template #top>
          <div class="d-flex align-center w-full">
            <div class="d-flex align-center">
              <v-icon size="21" class="mr-1">mdi-format-list-bulleted</v-icon>
              <span class="font-17 text-gray-900">Listagem dos produtos</span>

              <v-divider vertical class="mx-4" />

              <SysBtn @click="exportarRelatorio()">
                <v-icon left>$Excel</v-icon>
                exportar
              </SysBtn>
            </div>

            <v-spacer />

            <div class="w-400">
              <v-text-field
                v-model="pesquisar"
                label="Pesquisar"
                outlined
                hide-details
                dense
                append-icon="mdi-magnify"
                class="ma-2"
                v-lazy-input:debounce="2000"
                @input="pesquisarProduto()"
              />
            </div>
          </div>
        </template>

        <template #item.produto="{ item }">
          <div class="d-flex align-center">
            <DetalhesProduto
              v-if="item.idproduto"
              :produto="{ id_grupo: item.idgrupo, id_filial: item.filial, id_produto: item.idproduto }"
              class="ml-n3"
            />
            <span v-text="item.produto" class="text-truncate" />
          </div>
        </template>
        <template #item.estoque="{ value }">{{ Helpers.formatarValor(value) }}</template>
        <template #item.esseg="{ value }">{{ Helpers.formatarValor(value) }}</template>
        <template #item.pp="{ value }">{{ Helpers.formatarValor(value) }}</template>
        <template #item.emax="{ value }">{{ Helpers.formatarValor(value) }}</template>
        <template #item.projecao_venda="{ value }">{{ Helpers.formatarValor(value) }}</template>
        <template #item.preco_custo="{ value }">{{ Helpers.formatarValor(value) }}</template>
        <template #item.total_estoque="{ value }">{{ Helpers.formatarValor(value) }}</template>
        <template #item.estoque_em_excesso="{ value }">{{ Helpers.formatarValor(value) }}</template>
        <template #item.total_excesso="{ value }">{{ Helpers.formatarValorMonetario(value) }}</template>
      </sys-data-table>
    </SysDialogFullScreen>
  </div>
</template>

<script>
import responsiveHeight from '@/helpers/ResponsiveHeight.js';
import SysDialogFullScreen from '../../../padraoDeLayout/SysDialogFullScreen.vue';
import { logout } from "@/helpers";
import { buscarDadosDetalhesDialog } from '@/api/Indicadores/StatusProdutoV3';
import $axios from '@/api/api.js';
import DetalhesProduto from "@/components/produto/detalhes/Index";

export default {
  mixins: [responsiveHeight],
  components: { SysDialogFullScreen, DetalhesProduto },
  props: {
    dialog: Boolean,
    parametros: Object
  },
  model: {
    prop: 'dialog',
    event: 'change-dialog'
  },
  data: () => ({
    headers: [
      {value: 'comprador', text: 'Comprador' },
      {value: 'fornecedor', text: 'Fornecedor' },
      {value: 'produto', text: 'Produto' },
      {value: 'estoque', text: 'Estoque' },
      {value: 'esseg', text: 'Estoque Segurança' },
      {value: 'pp', text: 'Ponto de Pedido' },
      {value: 'emax', text: 'Estoque Máximo' },
      {value: 'projecao_venda', text: 'Projeção de Vendas' },
      {value: 'data_ult_saida', text: 'Data Última Saída' },
      {value: 'preco_custo', text: 'Preço médio de custo' },
      {value: 'total_estoque', text: 'Estoque (R$ custo)' },
      {value: 'estoque_em_excesso', text: 'Estoque Excesso' },
      {value: 'total_excesso', text: 'Estoque Excesso (R$ custo)' },
    ],
    desserts: [],
    pesquisar: '',
    tipos: {
      total_excesso: '1. Excesso',
      total_adequado: '2. Adequado',
      total_baixa_exposicao: '3. Baixa Exposição a Ruptura',
      total_elevada_exposicao: '4. Elevada Exposição a Ruptura',
      total_ruptura: '5. Em Ruptura'
    },
    produtos_por_pagina: 200,
    timerScrollDataTable: null,
    todosItensPaginadosCarregados: false
  }),
  computed: {
    DIALOG_COMPUTED: {
      get() { return this.dialog },
      set(valor) { this.$emit('change-dialog', valor) }
    },
    ARRAY_DESCRICAO_STATUS() {
      return [
        this.tipos[this.parametros.tipo],
        this.parametros.data,
      ];
    },
    PAGINA_ATUAL_PRODUTOS() {
      return Math.ceil(this.desserts.length / this.produtos_por_pagina);
    },
  },
  watch: {
    dialog (valor) {
      this.desserts = [];
      if (valor) this.buscarDados();
      else this.todosItensPaginadosCarregados = false;
    }
  },
  methods: {
    fecharDialog() {
      this.$emit('change-dialog', false);
    },
    pesquisarProduto() {
      if (!(this.pesquisar.length > 0)) return;
      this.desserts = [];
      this.todosItensPaginadosCarregados = false;
      this.buscarDados();
    },
    verificarFimScroll({scrollHeight, scrollTop, offsetHeight}) {
      if ((scrollTop + offsetHeight + 100) < scrollHeight || !(this.desserts.length > 0)) return;
      clearTimeout(this.timerScrollDataTable);
      this.timerScrollDataTable = setTimeout(() => this.buscarDados(), 500)
    },
    buscarDados() {
      if (this.todosItensPaginadosCarregados) return;

      const parametros = {
        ...this.parametros,
        pagina: (this.PAGINA_ATUAL_PRODUTOS + 1),
        pesquisa: this.pesquisar
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        buscarDadosDetalhesDialog(parametros)
          .then(detalhes => {
            this.desserts.push(...detalhes);

            if (detalhes.length < this.produtos_por_pagina) {
              this.todosItensPaginadosCarregados = true;
            }
          })
          .catch(logout)
      );
    },
    exportarRelatorio() {
      const url = $axios.defaults.baseURL + "/relatorios/indicadores/status-produtos";
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = url;
      form.target = '_blank';

      const input1 = document.createElement('input');
      input1.type = 'hidden';
      input1.name = 'parametros';
      input1.value = JSON.stringify(this.parametros);
      form.appendChild(input1);

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    }
  }
}
</script>

<style>

</style>
